import React from "react";
import NextLink from "next/link";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useTranslation } from "next-i18next";
import { alpha } from "@mui/material/styles";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { useTheme } from "@emotion/react";

import Container from "../../Common/Container";

const PartnershipReasons = () => {
  const theme = useTheme();
  const { t } = useTranslation("partnerships");

  return (
    <Container marginY={4}>
      <Box marginBottom={4}>
        <Box
          component={Typography}
          fontWeight={700}
          variant={"h3"}
          align={"center"}
          gutterBottom
        >
          {t("why_partner")}
        </Box>
      </Box>
      <Grid container spacing={8} justifyContent="center">
        {t("partnership_reasons", { returnObjects: true }).map((item, i) => (
          <Grid item xs={12} sm={6} md={4} key={`${i}-${item.title}`}>
            <Box component={Card} boxShadow={3} borderRadius={4}>
              <Box
                component={CardContent}
                display={"flex"}
                flexDirection={"column"}
                padding={{ xs: 2, sm: 4 }}
                sx={{
                  "&:last-child": {
                    paddingBottom: { xs: 2, sm: 4 },
                  },
                }}
              >
                <Box
                  component={Avatar}
                  variant="rounded"
                  width={40}
                  height={40}
                  marginBottom={2}
                  bgcolor={alpha(theme.palette.primary.main, 0.1)}
                  borderRadius={5}
                  p={2}
                >
                  <Typography
                    color="primary"
                    fontWeight="bold"
                    variant="h5"
                    component="span"
                  >
                    {i + 1}
                  </Typography>
                </Box>
                <Typography
                  variant={"h6"}
                  component="h4"
                  gutterBottom
                  fontWeight={500}
                >
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.subtitle}</Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Box marginTop={5} align="center">
        <NextLink href="/our-expertise" passHref>
          <Button
            variant="outlined"
            color="primary"
            component="a"
            size="large"
            endIcon={
              <svg
                width={16}
                height={16}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            }
          >
            {t("cta")}
          </Button>
        </NextLink>
      </Box>
    </Container>
  );
};

export default PartnershipReasons;
